export const errorConstants = {
  REQUEST_ERROR: "REQUEST_ERROR",
};
